<template>
  <b-input-group>
    <flat-pickr
      ref="flatpickr"
      :id="pickerId"
      :value="value"
      :config="monthConfig"
      :placeholder="placeholder"
      :disabled="disabled"
      :class="{ 'flat-pickr': true, 'form-control': true, 'border-right-0': true, ... withClass }"
      @input="(date) => $emit('input', date)"
      @on-change="(dates) => $emit('on-change', dates[0] || null)"
    />
    <b-input-group-append
      class="flatpickr-icon-container"
      :readonly="disabled"
      @click="openFlatpickr"
    >
      <i class="si si-calendar" />
    </b-input-group-append>
  </b-input-group>
</template>

<script>
import { uniqueId as _uniqueId } from 'lodash';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect/index.js';

export default {
  name: 'MonthPicker',
  props: {
    id: {
      type: String,
    },
    value: {
      type: [String, Date],
    },
    withClass: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    static: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
    },
  },
  data() {
    return {
      pickerId: this.id || `sfs-month-picker-${_uniqueId()}`,
    };
  },
  computed: {
    monthConfig() {
      return {
        mode: 'single',
        dateFormat: 'M Y',
        static: this.static,
        clickOpens: !this.disabled,
        closeOnSelect: true,
        plugins: [
          new monthSelectPlugin({
            shorthand: true,
            dateFormat: 'M Y',
          }),
        ],
      };
    },
  },
  methods: {
    openFlatpickr() {
      const fp = this.$refs.flatpickr?.fp;
      if (!this.disabled && fp && typeof fp.open === 'function') {
        fp.open();
      }
    },
  },
};
</script>
